import { FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

interface CookieBannerProps {
  onAccept: () => void;
  onReject: () => void;
  onSettings: () => void;
}

export const CookieBanner: FC<CookieBannerProps> = ({ onAccept, onReject, onSettings }) => {
  return (
    <aside className={styles.banner} role="dialog" aria-labelledby="cookie-banner-title">
      <div className={styles.bannerText}>
        <h2 id="cookie-banner-title">We value your privacy</h2>
        <p>
          We use cookies to ensure the website functions properly, improve user experience, and
          analyze website traffic. You can accept all cookies, reject non-essential cookies, or
          customize your preferences.
        </p>
        <Link to="/policies/policy" className={styles.policyLink}>
          Privacy and Cookies Policy
        </Link>
      </div>

      <div className={styles.bannerActions}>
        <button
          type="button"
          onClick={onSettings}
          className={`${styles.btn} ${styles.btnSecondary}`}
        >
          Cookie Settings
        </button>
        <div className={styles.bannerActions_manage}>
          <button
            type="button"
            onClick={onReject}
            className={`${styles.btn} ${styles.btnSecondary}`}
          >
            Reject
          </button>
          <button type="button" onClick={onAccept} className={`${styles.btn} ${styles.btnPrimary}`}>
            Accept All
          </button>
        </div>
      </div>
    </aside>
  );
};
